import PasswordResetForm from "./parts/PasswordResetForm";

export default function PasswordReset() {

  return (
    <PasswordResetForm />
  )
}